window.BUTCartDrawerCartNote = window.BUTCartDrawerCartNote || class BUTCartDrawerCartNote extends BUTCustomComponent {
  constructor() {
    super();
    this.addEventListener(
      "change",
      BUTHelper.debounce((event) => {
        const body = JSON.stringify({
          note: event.target.value,
        });
        fetch(`${window.routes.cart_update_url}`, {
          ...BUTHelper.fetchConfigJSON,
          ...{
            body,
          },
        });
      }, 300)
    );
  }
}
if (!customElements.get("but-cart-drwr-note")) {
  customElements.define("but-cart-drwr-note", window.BUTCartDrawerCartNote);
}

window.BUTCartDrawerQuantityInput = window.BUTCartDrawerQuantityInput || class BUTCartDrawerQuantityInput extends BUTCustomComponent {
  constructor() {
    super();
    this.input = this.$(`.js-cart-drawer-quantity-input`);
    this.changeEvent = new Event("change", {
      bubbles: true,
    });
    this.productQuantity = parseInt(this.dataset.productQuantity);
    this.cartNumber = BUTHelper.qs(".js-cart-drawer-count");
    this.renderCartNumbers();
    this.button = this.$$(".js-cart-drawer-quantity-btn");
    this.container = this.closest(".js-cart-drawer-quantity");
    this.message = this.container?.querySelector(".js-max-quantity-message");
    this.volumePricing = this.container?.querySelector("quantity-pricing");
    this.quantityMessage = this.container?.querySelector(
      ".js-quantity-pricing-message"
    );
    this.minQuantityMessage = this.container?.querySelector(
      ".js-min-quantity-pricing-message"
    );
    this.maxQuantityMessage = this.container?.querySelector(
      ".js-max-quantity-pricing-message"
    );
    this.stepQuantityMessage = this.container?.querySelector(
      ".js-step-quantity-pricing-message"
    );
    for (let i = 0, n = this.button.length; i < n; i++) {
      this.button[i].addEventListener(
        "click",
        this.onButtonClickHandler.bind(this)
      );
    }
    this.input.addEventListener("input", this.handleInputChange.bind(this));
    this.input.addEventListener("change", this.updatePriceItem.bind(this));
    this.updatePriceItem();
  }

  handleInputChange(event) {
    event.preventDefault();
    let value = parseInt(this.input.value) || 0;
    if (value <= this.productQuantity || Number.isNaN(value) || value == 0) {
      this.showMessage(true);
    } else {
      this.showMessage(false);
    }
  }

  onButtonClickHandler(event) {
    event.preventDefault();
    let previousValue = parseInt(this.input.value);
    let value;
    if (event.currentTarget.dataset.name === "plus") {
      value = parseInt(this.input.value) + 1;
    } else {
      value = parseInt(this.input.value) - 1;
    }
    if (value <= parseInt(this.productQuantity)) {
      event.currentTarget.dataset.name === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();
      this.showMessage(true);
      this.toggleAnimation("animated");
    } else {
      this.showMessage(false);
      this.toggleAnimation("error-animated");
    }
    if (previousValue !== parseInt(this.input.value)) {
      this.input.dispatchEvent(this.changeEvent);
    }
    this.renderCartNumbers();
    this.handleQuickOrderListForm();
  }

  validateQuantity(value) {
    const minValue = parseInt(this.input.min);
    const maxValue = parseInt(this.input.max);
    const stepValue = parseInt(this.input.step);

    const toggleMessage = (message, show) => {
      message?.classList.toggle("d-none-important", !show);
    };

    const showMessages = (show, min, max, step) => {
      toggleMessage(this.quantityMessage, show);
      toggleMessage(this.minQuantityMessage, min);
      toggleMessage(this.maxQuantityMessage, max);
      toggleMessage(this.stepQuantityMessage, step);
    };

    if (value < minValue) {
      showMessages(true, true, false, false);
    } else if (value > maxValue) {
      showMessages(true, false, true, false);
    } else if (value % stepValue !== 0) {
      showMessages(true, false, false, true);
    } else {
      showMessages(false, false, false, false);
    }
  }

  toggleAnimation(animationClass) {
    const oppositeClass =
      animationClass === "animated" ? "error-animated" : "animated";
    this.input.classList.remove(oppositeClass);
    if (this.input.classList.contains(animationClass))
      this.input.classList.remove(animationClass);
    void this.input.offsetWidth; // Trigger reflow
    this.input.classList.add(animationClass);
  }

  showMessage(show) {
    if (!this.message) return;
    if (show) {
      if (!this.message.classList.contains("d-none-important"))
        this.message.classList.add("d-none-important");
      if (this.input.value > 0) this.validateQuantity(this.input.value);
    } else {
      const messages = [
        this.quantityMessage,
        this.minQuantityMessage,
        this.maxQuantityMessage,
        this.stepQuantityMessage,
      ];

      messages.forEach((message) => {
        if (message && !message.classList.contains("d-none-important")) {
          message.classList.add("d-none-important");
        }
      });
      this.message.classList.remove("d-none-important");
    }
  }

  updatePriceItem() {
    let minPricingMoney = null;
    let currentValue = parseInt(this.input.value);
    this.volumePricing?.querySelectorAll("li").forEach((item) => {
      const quantity = parseInt(
        item.querySelector(".js-pricing-item-quantity").textContent
      );
      const priceText = item.querySelector(
        ".js-pricing-item-price"
      )?.textContent;
      if (currentValue >= quantity) {
        minPricingMoney = priceText;
      }
    });
    const priceDisplay = this.closest(".js-cart-drawer-item")?.querySelector(
      ".price-item"
    );
    if (
      minPricingMoney !== null &&
      priceDisplay &&
      priceDisplay.textContent !== minPricingMoney
    ) {
      priceDisplay.textContent = minPricingMoney;
    }
  }

  handleQuickOrderListForm() {
    const container = this.closest(".js-cart-drawer-quantity");
    const variantId = container?.dataset.variantId;
    const quickOrderListVariant = BUTHelper.qsa(".js-order-list-item");
    quickOrderListVariant.forEach((item) => {
      if (item.dataset.variantId == variantId) {
        const input = item.querySelector(".js-quantity-input");
        input.value = this.input.value;

        const changeEvent = new Event("change", { bubbles: true });
        input.dispatchEvent(changeEvent);
      }
    });
  }

  renderCartNumbers() {
    if (this.cartNumber) {
      let totalItems = 0;
      const inputs = BUTHelper.qsa(".js-cart-drawer-quantity-input");
      inputs.forEach((input) => {
        totalItems += parseInt(input.value, 10);
      });
      this.cartNumber.innerHTML = totalItems;
    }
  }
}

if (!customElements.get("but-cart-drwr-qty-inp")) {
  customElements.define("but-cart-drwr-qty-inp", window.BUTCartDrawerQuantityInput);
}

window.BUTCartDrawerRemoveButton = window.BUTCartDrawerRemoveButton || class BUTCartDrawerRemoveButton extends BUTCustomComponent {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("but-cart-drwr-frm").updateQuantity(this.dataset.index, 0);
      this.handleQuickOrderListForm();
    });
  }

  handleQuickOrderListForm() {
    const container = this.closest(".js-cart-drawer-quantity");
    const variantId = container?.dataset.variantId;
    const quickOrderListVariant = BUTHelper.qsa(".js-order-list-item");
    quickOrderListVariant.forEach((item) => {
      if (item.dataset.variantId == variantId) {
        const input = item.querySelector(".js-quantity-input");
        const removeBtn = item.querySelector("but-remove-btn");
        input.value = 0;
        removeBtn.classList.add("d-none-important");

        const changeEvent = new Event("change", { bubbles: true });
        input.dispatchEvent(changeEvent);
      }
    });
  }
}
if (!customElements.get("but-cart-drwr-rmv-btn")) {
  customElements.define("but-cart-drwr-rmv-btn", window.BUTCartDrawerRemoveButton);
}

window.BUTCartDrawerForm = window.BUTCartDrawerForm || class BUTCartDrawerForm extends BUTCustomComponent {
  constructor() {
    super();
    this.totalItems = Array.from(
      this.$$(".js-cart-drawer-quantity-input")
    ).reduce((total, ele) => total + parseInt(ele.value), 0);
    this.drawerCartElement = BUTHelper.qs("but-cart-drwr");
    this.wrapperElement = this.drawerCartElement.querySelector(
      ".js-cart-drawer-wrapper"
    );
    this.cartNotification = BUTHelper.qs("but-cart-noti");
    this.linkToCart = BUTHelper.qs(".js-link-to-cart");
    this.quantityPricingBtn = this.$$(".js-quantity-pricing-btn");
    this.cartUpdateRequestId = 0;
    this.onCartUpdate = this.handleCartUpdate.bind(this);

    this.addEventListener(
      "change",
      BUTHelper.debounce((event) => {
        this.onChange(event);
      }, 300)
    );

    this.onClickQuantityPricingBtn();
  }

  connectedCallback() {
    // The hidden empty-state template holds a copy of this element; only the
    // one on screen refreshes the drawer.
    if (this.closest(".js-drawer-empty")) return;
    document.addEventListener("cart:update", this.onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener("cart:update", this.onCartUpdate);
  }

  handleCartUpdate() {
    // Latest request wins, so two quick changes (apply a code, then remove
    // it) can never leave the drawer showing the older cart.
    const requestId = ++this.cartUpdateRequestId;
    const isStale = () => requestId !== this.cartUpdateRequestId;

    let sections = this.getSectionsToRender();
    if (this.cartNotification) {
      sections = [...sections, ...this.cartNotification.getSectionsToRender()];
    }

    fetch(`${window.routes.cart_url}`, {
      ...BUTHelper.fetchConfig,
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        if (isStale()) return;
        if (cart.item_count === 0) {
          let cartEmpty = BUTHelper.qs(".js-drawer-empty");
          let cartDrawer = BUTHelper.qs(".js-cart-drawer-wrapper");
          let cartCountNumber = BUTHelper.qs(".js-cart-count-number");
          cartDrawer.innerHTML = cartEmpty.innerHTML;
          cartCountNumber.innerHTML = 0;
          BUTHelper.qid("cartDrawer")?.classList.add("cart-empty-container");

          // Dispatch cart:updated event to notify that cart update is complete
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              source: 'cart-drawer',
              cart: cart
            }
          }));
        } else {
          fetch(
            `?sections=${sections.map((section) => section.section).join(",")}`
          )
            .then((response) => response.text())
            .then((state) => {
              if (isStale()) return;
              const parsedState = JSON.parse(state);
              this.renderContentsDiscount({ sections: parsedState });
              
              // Update header cart status
              if (this.cartNotification && parsedState) {
                this.cartNotification.getSectionsToRender().forEach((section) => {
                  if (section.id == "header-cart-status") {
                    const headerElement = BUTHelper.qs(section.space_selector);
                    if (headerElement && parsedState[section.id]) {
                      const sectionHTML = this.cartNotification.getSectionInnerHTML(
                        parsedState[section.id],
                        section.selector
                      );
                      if (sectionHTML !== null) {
                        headerElement.innerHTML = sectionHTML;
                      }
                    }
                  }
                });
              }
              
              // Update header cart count directly if header-cart-status section not available
              const cartCountNumber = BUTHelper.qs(".js-cart-count-number");
              if (cartCountNumber && cart.item_count !== undefined) {
                cartCountNumber.textContent = cart.item_count;
              }
              
              // Dispatch cart:updated event to notify that cart update is complete
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                  source: 'cart-drawer',
                  cart: cart
                }
              }));
            })
            .catch((error) => {
              console.error("Error fetching cart sections:", error);
            });
        }
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }

  renderContentsDiscount(parsedState) {
    this.wrapperElement.classList.contains("is-empty") &&
      this.wrapperElement.classList.remove("is-empty");
    BUTHelper.qid("cartDrawer")?.classList.remove("cart-empty-container");
    this.getSectionsToRenderDiscount().forEach((section) => {
      section.selectors?.forEach((e) => {
        let tmpElement = BUTHelper.qid(section.id);
        if (tmpElement && parsedState.sections[section.section]) {
          let shouldBeReplacedElm = tmpElement.querySelector(e);
          if (shouldBeReplacedElm) {
            const sectionHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              e
            );
            if (sectionHTML !== null) {
              shouldBeReplacedElm.innerHTML = sectionHTML;
            }
          }
        }
      });
    });
  }

  getSectionsToRenderDiscount() {
    return [
      {
        id: "cartDrawer",
        section: "cart-drawer",
        selectors: [
          ".js-cart-items",
          ".js-discount-pills",
          ".js-cart-drawer-total",
          ".js-cart-drawer-free-shipping",
        ],
      },
      // The cart page (#mainCart) refreshes itself on "cart:update" - see
      // assets/component-cart.js - so it keeps its real section settings.
    ];
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.dataset.name
    );
  }

  onClickQuantityPricingBtn() {
    this.quantityPricingBtn?.forEach((btn) => {
      if (window.matchMedia("(max-width: 1024px)").matches) {
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          btn.classList.toggle("active");
        });
      } else {
        btn.parentElement.addEventListener("mouseleave", () => {
          btn.classList.remove("active");
        });
        btn.parentElement.addEventListener("mouseenter", () => {
          btn.classList.add("active");
        });
      }

      document.addEventListener("click", (event) => {
        if (!btn.parentElement.contains(event.target)) {
          btn.classList.remove("active");
        }
      });
    });
  }

  renderContents(parsedState) {
    this.wrapperElement.classList.contains("is-empty") &&
      this.wrapperElement.classList.remove("is-empty");
    BUTHelper.qid("cartDrawer")?.classList.remove("cart-empty-container");
    this.getSectionsToRender().forEach((section) => {
      section.selectors?.forEach((e) => {
        let tmpElement = BUTHelper.qid(section.id);

        if (tmpElement && parsedState.sections[section.section]) {
          let shouldBeReplacedElm = tmpElement.querySelector(e) || tmpElement;
          shouldBeReplacedElm.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            e
          );
        }
      });
    });
  }
  getSectionsToRender() {
    return [
      {
        id: "cartDrawer",
        section: "cart-drawer",
        selectors: [".js-cart-drawer-wrapper"],
      },
      // #mainCart is refreshed by assets/component-cart.js, which listens for
      // the "cart:updated" event dispatched from updateQuantity().
    ];
  }
  updateQuantity(line, quantity, name) {
    let sections = this.getSectionsToRender();
    let parsedState = {};
    if (this.cartNotification) {
      sections = [...sections, ...this.cartNotification.getSectionsToRender()];
    }

    let body = JSON.stringify({
      line,
      quantity,
      sections: sections.map((section) => section.section),
      sections_url: window.location.pathname,
    });
    this.updateButtonState(true);
    fetch(`${window.routes.cart_change_url}`, {
      ...BUTHelper.fetchConfigJSON,
      ...{
        body,
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        parsedState = JSON.parse(state);
        this.closest(".js-cart-drawer-wrapper").classList.toggle(
          "is-empty",
          parsedState.item_count === 0
        );
        if (parsedState.item_count == 0) {
          let cartEmpty = BUTHelper.qs(".js-drawer-empty");
          let cartDrawer = BUTHelper.qs(".js-cart-drawer-wrapper");
          let cartCountNumber = BUTHelper.qs(".js-cart-count-number");
          cartDrawer.innerHTML = cartEmpty.innerHTML;
          cartCountNumber.innerHTML = 0;
          BUTHelper.qid("cartDrawer")?.classList.add("cart-empty-container");
        } else {
          this.getSectionsToRender().forEach((section) => {
            section.selectors.forEach((e) => {
              let tepItem = BUTHelper.qid(section.id);
              if (tepItem) {
                let shouldBeReplacedElm = tepItem.querySelector(e) || tepItem;

                if (section.id === "cartDrawer" && quantity > 0) {
                  const newDoc = new DOMParser().parseFromString(
                    parsedState.sections[section.section],
                    "text/html"
                  );

                  // Single-instance regions: update in place to avoid
                  // re-rendering the whole item list on every +/- click.
                  [
                    ".js-cart-drawer-free-shipping",
                    ".js-cart-drawer-footer",
                  ].forEach((selector) => {
                    const target = shouldBeReplacedElm.querySelector(selector);
                    const source = newDoc.querySelector(selector);
                    if (target && source) target.innerHTML = source.innerHTML;
                  });

                  // Per-line price: there is one .js-cart-drawer-price node per
                  // cart line, so querySelector() (first match only) left every
                  // line except the first one stale when the cart had 2+ items.
                  // Update each line's price by position instead. The quantity
                  // controls are left untouched so the input the shopper is
                  // clicking is never re-rendered mid-interaction.
                  const priceTargets = shouldBeReplacedElm.querySelectorAll(
                    ".js-cart-drawer-price"
                  );
                  const priceSources = newDoc.querySelectorAll(
                    ".js-cart-drawer-price"
                  );
                  priceTargets.forEach((target, i) => {
                    if (priceSources[i])
                      target.innerHTML = priceSources[i].innerHTML;
                  });
                } else {
                  shouldBeReplacedElm.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    e
                  );
                }
              }
            });
          });
          let lineItem = BUTHelper.qid(`cartDrawerItem-${line}`);
          if (lineItem) {
            let quantityBtn = lineItem.querySelector(
              `.js-cart-drawer-quantity-btn-${name}`
            );
            quantityBtn && quantityBtn.focus();
          }
          /* Update header status */
          if (this.cartNotification) {
            this.cartNotification.getSectionsToRender().forEach((section) => {
              if (section.id == "header-cart-status") {
                BUTHelper.qs(section.space_selector).innerHTML =
                  this.cartNotification.getSectionInnerHTML(
                    parsedState.sections[section.id],
                    section.selector
                  );
              }
            });
          }
          /* Update header status */
        }
      })
      .then(() => {
        if (!parsedState.errors) {
          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: { source: "cart-drawer-quantity", cart: parsedState },
            })
          );
        }
      })
      .catch((e) => {
        this.$(".js-cart-drawer-errors").textContent = BUTLanguage.cart.ERROR;
      })
      .finally(() => {
        this.updateButtonState(false);
        this.drawerCartElement.updateSwiperOpened();
      });
  }

  getSectionInnerHTML(html, selector) {
    const parsedDoc = new DOMParser().parseFromString(html, "text/html");
    const element = parsedDoc.querySelector(selector);
    return element ? element.innerHTML : null;
  }
  updateButtonState(disabled) {
    let btn = this.$$(".js-cart-drawer-btn");
    let btnSubmit = this.drawerCartElement.querySelector(
      ".js-cart-drawer-submit-btn"
    );
    if (disabled) {
      for (let i = 0, n = btn.length; i < n; i++) {
        btn[i].setAttribute("disabled", "disabled");
      }
      btnSubmit && btnSubmit.setAttribute("disabled", "disabled");
    } else {
      for (let i = 0, n = btn.length; i < n; i++) {
        btn[i].removeAttribute("disabled", "disabled");
      }
      btnSubmit && btnSubmit.removeAttribute("disabled");
    }
  }
}
if (!customElements.get("but-cart-drwr-frm")) {
  customElements.define("but-cart-drwr-frm", window.BUTCartDrawerForm);
}

class BUTMessageAddToCartSuccess extends BUTCustomComponent {
  constructor() {
    super();
    this.autoHideTimer = null;
    this.closeFallbackTimer = null;
    this.onCloseAnimationEnd = () => this.finishHide();
  }
  setActiveMessage(t = !0) {
    clearTimeout(this.autoHideTimer);
    clearTimeout(this.closeFallbackTimer);
    this.removeEventListener("animationend", this.onCloseAnimationEnd);
    this.classList.remove("is-closing");
    if (t) {
      this.classList.remove("d-none");
      this.classList.add("d-flex");
      this.autoHideTimer = setTimeout(() => this.hideMessage(), 3000);
    } else {
      this.hideMessage();
    }
  }
  hideMessage() {
    clearTimeout(this.autoHideTimer);
    if (!this.classList.contains("d-flex")) return;
    this.classList.add("is-closing");
    this.addEventListener("animationend", this.onCloseAnimationEnd, {
      once: true,
    });
    // Fallback in case animationend never fires (e.g. reduced-motion)
    this.closeFallbackTimer = setTimeout(() => this.finishHide(), 250);
  }
  finishHide() {
    clearTimeout(this.closeFallbackTimer);
    this.removeEventListener("animationend", this.onCloseAnimationEnd);
    this.classList.remove("d-flex", "is-closing");
    this.classList.add("d-none");
  }
}
customElements.define("but-message-success", BUTMessageAddToCartSuccess);

class BUTFreeShippingBar extends BUTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    this.total_price = this.dataset.totalPrice;
    this.threshold = 0;
    this.original_free_shipping_price = this.dataset.freeShippingOriginalPrice;
    this.free_shipping_price = this.dataset.freeShippingPrice;
    this.free_shipping_progress = this.$(`.js-free-shipping-progress`);
    this.free_shipping_progress_content = this.$(`.js-free-shipping-progress-content`);
    this.free_shipping_progress_message = this.$(`.js-free-shipping-message`);

    this.init();
  }

  calculateCurrencyRate() {
    this.threshold = Math.round(this.free_shipping_price * (Shopify.currency.rate || 1));
  }

  init() {
    this.calculateCurrencyRate();
    this.free_shipping_progress.max = this.threshold;
    this.free_shipping_progress.value = this.total_price;
    this.free_shipping_progress_content.innerHTML = BUTHelper.formatMoney(this.threshold, window.theme_variables.settings.money_format);

    let remain = this.threshold - this.total_price;
    if (remain <= 0) {
      this.free_shipping_progress_message.innerHTML = "<span class='success-free-shipping-message'>" + BUTLanguage.free_shipping_bar.FULFILLED + "</span>";
      this.free_shipping_progress_content.innerHTML = "<span class='success-free-shipping-message'><svg xmlns='http://www.w3.org/2000/svg' width='15' height='11' viewBox='0 0 15 11' fill='none'><path d='M13.5774 0.244078C13.9028 -0.0813592 14.4304 -0.0813592 14.7558 0.244078C15.0812 0.569515 15.0812 1.09703 14.7558 1.42246L5.58913 10.5891C5.26369 10.9146 4.73618 10.9146 4.41074 10.5891L0.244078 6.42246C-0.0813592 6.09703 -0.0813592 5.56952 0.244078 5.24408C0.569515 4.91864 1.09703 4.91864 1.42246 5.24408L4.99994 8.82155L13.5774 0.244078Z' fill='#0C8A00'/></svg></span>";
    } else {
      this.free_shipping_progress_message.innerHTML = BUTLanguage.free_shipping_bar.UNFULFILLED.replaceAll("[amount]", "<span class='price-cart-shipping'>" + BUTHelper.formatMoney(remain, window.theme_variables.settings.money_format) + "</span>");
      this.free_shipping_progress_content.innerHTML = BUTHelper.formatMoney(this.threshold, window.theme_variables.settings.money_format);
    }
  }
}
customElements.define("but-free-shipping-bar", BUTFreeShippingBar);